import request from "@/utils/request";
import Qs from "qs";

// 添加园区装修配置
export function setAdd(data) {
  return request({
    url: "/renovation/set_add",
    method: "post",
    // ContentType:'multipart/form-data',
    data: Qs.stringify(data),
  });
}

// 编辑园区装修配置
export function setEdit(data) {
  return request({
    url: "/renovation/set_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除园区装修配置
export function setDel(data) {
  return request({
    url: "/renovation/set_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 园区装修配置详情
export function setInfo(data) {
  return request({
    url: "/renovation/set_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 园区装修配置列表
export function setList(data) {
  return request({
    url: "/renovation/set_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 装修申请-列表
export function applyList(data) {
  return request({
    url: "/renovation/apply_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 装修申请--审核
export function applyExamine(data) {
  return request({
    url: "/renovation/apply_examine",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 装修申请-详情
export function applyInfo(data) {
  return request({
    url: "/renovation/apply_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 装修申请-编辑
export function applyEdit(data) {
  return request({
    url: "/renovation/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 装修申请--装修延期
export function applyDelay(data) {
  return request({
    url: "/renovation/delay",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 装修任务-列表
export function taskList(data) {
  return request({
    url: "/renovation/task_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 装修任务-详情
export function taskInfo(data) {
  return request({
    url: "/renovation/task_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 装修任务-新增巡检登记
export function taskPunchAdd(data) {
  return request({
    url: "/renovation/punch_add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 装修任务-验收
export function taskCheck(data) {
  return request({
    url: "/renovation/check",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 装修任务-关闭
export function taskClose(data) {
  return request({
    url: "/renovation/close",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 装修任务-关闭
export function apply_comment(data) {
  return request({
    url: "/renovation/apply_comment",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 装修巡检记录-列表
export function punchList(data) {
  return request({
    url: "/renovation/punch_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 装修巡检记录-巡检详情
export function punchInfo(data) {
  return request({
    url: "/renovation/punch_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 装修申请--新增申请
export function applyAdd(data) {
  return request({
    url: "/renovation/apply_add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 装修统计--柱状图以及 统计数据
export function getStatistics(data) {
  return request({
    url: "/renovation/statistics",
    method: "post",
    data: Qs.stringify(data),
  });
}
